import { render, staticRenderFns } from "./novel_success.vue?vue&type=template&id=9774150c"
import script from "./novel_success.vue?vue&type=script&lang=js"
export * from "./novel_success.vue?vue&type=script&lang=js"
import style0 from "./novel_success.vue?vue&type=style&index=0&id=9774150c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports